module.exports = __webpack_public_path__ + "media/8.859e50dd.mp3";